import React from 'react';
import { Dropdown } from 'semantic-ui-react';

//Create a docstring for the component
/**
 * DropdownComponent is a reusable component that renders a dropdown.
 * @param {string} selection - The selection type of the dropdown for selection of various options of dropdown menu.
 * @param {string} value - The value or label of the dropdown.
 * @param {function} onChange - The function that handles the change state of the dropdown.
 * @param {array} options - The options of the dropdown.
 * @param {string} className - The class name of the dropdown.
 **/


const DropdownComponent = ({ selection, value, onChange, options, className, dataCy, icon,disabled }) => {
  return (
    <Dropdown
      selection={selection}
      value={value}
      onChange={onChange}
      options={options}
      className={className}
      data-cy={dataCy}
      icon={icon}
      disabled={disabled}
    />
  );
};

export default DropdownComponent;